import React, { useState } from 'react';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon, MailIcon, PhoneIcon, Trash2Icon } from 'lucide-react';
import { Button, LinkButton, buttonClasses } from '../../components/ui/Button';
import { TextField } from '../../components/ui/Field';
import { StatusBadge } from '../../components/admin/StatusBadge';
import { useAdminData } from '../../contexts/AdminDataContext';
import { formatDate } from '../../utils/format';
export function CustomerDetail() {
  const {
    customerId
  } = useParams();
  const navigate = useNavigate();
  const {
    customers,
    casesForCustomer,
    updateCustomer,
    deleteCustomer
  } = useAdminData();
  const customer = customers.find(entry => entry.id === customerId);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(customer);
  if (!customer) return <Navigate to="/admin/kunder" replace data-id="element-382" data-mp="21726le5a1gkr" />;
  const list = [...casesForCustomer(customer.id)].sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  return <div className="px-5 py-7 md:px-8 md:py-10" data-id="element-383" data-mp="2v5rhhiafy7v7">
      <Link to="/admin/kunder" className="inline-flex items-center gap-2 text-sm text-ink-muted transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-384" data-mp="2v8ng78u450kp">
        <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-385" data-mp="352w9hyqywxjx" />
        Kunder
      </Link>

      <div className="mt-4 flex flex-wrap items-start justify-between gap-4" data-id="element-386" data-mp="306p01vzd53x8">
        <h1 className="font-display text-[clamp(1.8rem,5vw,2.5rem)] font-bold leading-[1.05] tracking-tight text-ink" data-id="element-387" data-mp="2ch32te2jwyrv">
          {customer.name}
        </h1>
        <button type="button" onClick={() => {
        if (window.confirm(`Slet ${customer.name}? Kundens sager slettes også. Handlingen kan ikke fortrydes.`)) {
          deleteCustomer(customer.id);
          navigate('/admin/kunder');
        }
      }} className="inline-flex h-9 items-center gap-2 rounded-full border border-line px-3.5 text-sm text-ink-soft transition-colors duration-200 ease-smooth hover:border-ink/30 hover:text-ink" data-id="element-388" data-mp="2m5uqvb4hqyxi">
          <Trash2Icon className="h-4 w-4" aria-hidden="true" data-id="element-389" data-mp="3tq8jjhg6kqgq" />
          Slet kunde
        </button>
      </div>

      <div className="mt-6 grid gap-5 lg:grid-cols-[0.7fr_1.3fr]" data-id="element-390" data-mp="2fi4o7hkwrzp">
        <section className="rounded-card border border-line bg-white p-6" data-id="element-391" data-mp="6dpf6klg8x2g">
          <div className="flex items-center justify-between gap-3" data-id="element-392" data-mp="35uw1ld11bzqc">
            <h2 className="text-xs font-semibold uppercase tracking-wider text-ink-muted" data-id="element-393" data-mp="3at7bfnrbya8k">
              Kundeoplysninger
            </h2>
            {!editing && <button type="button" onClick={() => {
            setDraft(customer);
            setEditing(true);
          }} className="text-sm font-medium text-accent hover:text-accent-deep" data-id="element-394" data-mp="3ethgmy7aswmd">
                Rediger
              </button>}
          </div>

          {editing && draft ? <form className="mt-4 space-y-4" onSubmit={event => {
          event.preventDefault();
          updateCustomer(customer.id, draft);
          setEditing(false);
        }} data-id="element-395" data-mp="1973914w3xot7">
              <TextField id="kd-navn" label="Navn" required value={draft.name} onChange={event => setDraft({
            ...draft,
            name: event.target.value
          })} data-id="element-396" data-mp="vgg8r8ap7qv0" />
              <TextField id="kd-tlf" label="Telefon" type="tel" value={draft.phone} onChange={event => setDraft({
            ...draft,
            phone: event.target.value
          })} data-id="element-397" data-mp="lgfmpelg2wn4" />
              <TextField id="kd-mail" label="E-mail" type="email" value={draft.email} onChange={event => setDraft({
            ...draft,
            email: event.target.value
          })} data-id="element-398" data-mp="2awout8s363kl" />
              <TextField id="kd-adresse" label="Adresse" value={draft.address} onChange={event => setDraft({
            ...draft,
            address: event.target.value
          })} data-id="element-399" data-mp="2dz35j8q0umys" />
              <TextField id="kd-noter" label="Noter" value={draft.notes} onChange={event => setDraft({
            ...draft,
            notes: event.target.value
          })} data-id="element-400" data-mp="28zgpysmq0umt" />
              <div className="flex gap-3 pt-1" data-id="element-401" data-mp="1zzach6r0vunn">
                <Button type="submit" size="sm" data-id="element-402" data-mp="2003gw12ie82m">
                  Gem
                </Button>
                <Button type="button" variant="secondary" size="sm" onClick={() => setEditing(false)} data-id="element-403" data-mp="1lbpbpjhme7iw">
                  Annuller
                </Button>
              </div>
            </form> : <>
              <dl className="mt-4 space-y-3 text-[15px]" data-id="element-404" data-mp="1h8awgv1i9v6i">
                <div data-id="element-405" data-mp="1h7rddb04d0qw">
                  <dt className="text-ink-muted" data-id="element-406" data-mp="1hadil3zjf45y">Navn</dt>
                  <dd className="mt-0.5 text-ink" data-id="element-407" data-mp="xnk2zd8ahy9v">{customer.name}</dd>
                </div>
                <div data-id="element-408" data-mp="so7l76w9zhe5">
                  <dt className="text-ink-muted" data-id="element-409" data-mp="soz35ewy9gly">Telefon</dt>
                  <dd className="mt-0.5 text-ink" data-id="element-410" data-mp="16np10wrlfkbd">{customer.phone || '—'}</dd>
                </div>
                <div data-id="element-411" data-mp="12l2gzi15z3oq">
                  <dt className="text-ink-muted" data-id="element-412" data-mp="12kiurp4hdt4w">E-mail</dt>
                  <dd className="mt-0.5 break-all text-ink" data-id="element-413" data-mp="1gld72iunge8u">{customer.email || '—'}</dd>
                </div>
                <div data-id="element-414" data-mp="1bmjqghk2g74g">
                  <dt className="text-ink-muted" data-id="element-415" data-mp="1bl8q6rptxhi3">Adresse</dt>
                  <dd className="mt-0.5 text-ink" data-id="element-416" data-mp="1qb6i9iqvqrck">{customer.address || '—'}</dd>
                </div>
                <div data-id="element-417" data-mp="1lc3bntv94d2h">
                  <dt className="text-ink-muted" data-id="element-418" data-mp="1lbjx8n4t86t7">Noter</dt>
                  <dd className="mt-0.5 text-ink" data-id="element-419" data-mp="1le6a92agzeit">{customer.notes || 'Ingen noter.'}</dd>
                </div>
              </dl>
              <div className="mt-6 flex flex-col gap-2 sm:flex-row" data-id="element-420" data-mp="1ud1g2d9lqmll">
                <LinkButton href={`tel:${customer.phone}`} variant="secondary" size="sm" data-id="element-421" data-mp="1uaouzr8jrw4b">
                  <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-422" data-mp="rx91cx8k03s3" />
                  Ring
                </LinkButton>
                <LinkButton href={`mailto:${customer.email}`} variant="secondary" size="sm" data-id="element-423" data-mp="1101tf2pk8jiz">
                  <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-424" data-mp="10y7aftxun1hj" />
                  Send e-mail
                </LinkButton>
              </div>
            </>}
        </section>

        <section className="rounded-card border border-line bg-white" data-id="element-425" data-mp="1arxvspyoivt0">
          <header className="border-b border-line px-5 py-4" data-id="element-426" data-mp="1fnd3t1a09xhi">
            <h2 className="font-display text-lg font-bold tracking-tight text-ink" data-id="element-427" data-mp="1knhol3hy5edj">Sager</h2>
          </header>
          <ul className="divide-y divide-line" data-id="element-428" data-mp="1opw6nldska3r">
            {list.map(item => <li key={item.id} className="flex flex-wrap items-center justify-between gap-3 px-5 py-4" data-id="element-429" data-mp="3mfw1fo5mvsn3">
                <div className="min-w-0" data-id="element-430" data-mp="3qg7kiwiclkwg">
                  <p className="text-[15px] text-ink" data-id="element-431" data-mp="3qh979y8q7vu0">
                    <span className="font-medium" data-id="element-432" data-mp="3ixq7whf6dpz9">Sag #{item.number}</span> – {item.title}
                  </p>
                  <p className="mt-0.5 text-sm text-ink-muted" data-id="element-433" data-mp="3e5oz55h7uhdz">{formatDate(item.plannedDate)}</p>
                </div>
                <div className="flex items-center gap-3" data-id="element-434" data-mp="3986n367wjm1r">
                  <StatusBadge status={item.status} data-id="element-435" data-mp="356levy6bbvxw" />
                  <Link to={`/admin/sager/${item.id}`} className={buttonClasses('secondary', 'sm')} data-id="element-436" data-mp="357whvvrxozny">
                    Åbn
                  </Link>
                </div>
              </li>)}
            {list.length === 0 && <li className="px-5 py-10 text-center text-sm text-ink-muted" data-id="element-437" data-mp="3sve6jifwjhmp">
                Ingen sager på denne kunde endnu.
              </li>}
          </ul>
          {list.length > 0 && <div className="border-t border-line px-5 py-4" data-id="element-438" data-mp="2hh0l0k8mfe9u">
              <p className="text-sm text-ink-muted" data-id="element-439" data-mp="2he4kqp9awdi8">
                {list.length} {list.length === 1 ? 'sag' : 'sager'} i alt på denne kunde.
              </p>
            </div>}
        </section>
      </div>
    </div>;
}